import { Component } from '@angular/core';
import { Feature } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-contests',
  template: `
    <app-bar
      i18n-appBarTitle="Secondary navigation contest bar title"
      appBarTitle="Contests"
      link="/contest"
      flTrackingSection="SubnavContests"
    >
      <app-bar-item
        link="/contest"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="Overview"
        [exactLink]="true"
      >
        Overview
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.CONTEST_POST"
        link="/contest/create.php"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="GoToPostContest"
        [exactLink]="true"
      >
        Start a Contest
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.SEARCH"
        link="/contest/browse"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="BrowseContests"
      >
        Browse Contests
      </app-bar-item>
      <app-bar-item
        *flFeature="Feature.SHOWCASE"
        link="/showcase"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="Showcase"
        [exactLink]="true"
      >
        Showcase
      </app-bar-item>
      <app-bar-item
        link="/contest-info"
        i18n="Secondary navigation contest bar item"
        flTrackingLabel="LearnMore"
        [exactLink]="true"
      >
        Learn More
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryContestsComponent {
  ButtonColor = ButtonColor;
  Feature = Feature;
}
